module.exports = __webpack_public_path__ + "static/media/dashboard.01d7191d.png";